<template>
  <div class="mt__main">
    <div class="mt__center">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/about' }">关于名通</el-breadcrumb-item>
        <el-breadcrumb-item>大事记</el-breadcrumb-item>
      </el-breadcrumb>
      <br>
      <el-card class="mt__card" :body-style="{  }" shadow="never">
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "memorabilia",
  data() {
    return {
      newsData: []
    };
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {}
};
</script>

<style scoped>
.mt__main {
  background-color: #f5f5f5;
}
.mt__main > .mt__center {
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/memorabilia.vue